import { Link } from 'react-router-dom';
import PublicLayout from '../layouts/PublicLayout';
import { ROUTE_PATHS } from '../routes/routePaths';

function NotFoundPage() {
  return (
    <PublicLayout>
      <section>
        <p className="text-sm font-semibold text-primary-300">Error 404</p>
        <h1 className="mt-3 text-4xl font-semibold text-white">
          Página no encontrada
        </h1>
        <p className="mt-4 text-slate-400">
          La dirección que buscas todavía no está disponible.
        </p>
        <Link
          to={ROUTE_PATHS.HOME}
          className="mt-7 inline-flex rounded-lg bg-primary-400 px-4 py-2.5 text-sm font-semibold text-slate-950 transition hover:bg-primary-300"
        >
          Volver al inicio
        </Link>
      </section>
    </PublicLayout>
  );
}

export default NotFoundPage;
